import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useState} from 'react';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {PersonaStatus} from '../types';

export const IndexPage = () => {
    const [statusFilter, setStatusFilter] = useState<PersonaStatus | null>(PersonaStatus.ENABLED);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader onFilterChange={setStatusFilter}/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable statusFilter={statusFilter}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
